<template>
    <div>
        <x-modal class="signature"
                 :class="{ portrait: mode == 'portrait-primary', 'landscape': mode == 'landscape-primary', mobile:  $isMobile}"
                 :wWidth="1080" v-if="visible" @close="visible = false" :footer="false">
            <div slot="title" :class="`truncate`">
                {{ customerSignature ? `Adopt your Signature` : `Confirm your name and signatures` }}
            </div>
            <div class="container col-12 mx-2 p-0" style="position:relative;">
                <div
                    class="row pt-0 amb-modal-body"
                    id="bounding-north"
                    style="-ms-overflow-y: auto; overflow-y: auto; max-height:700px;">
                    <div class="col-12" v-if="customerSignature">
                        <img :src="customerSignature.temporary_url" class="img-fluid mt-2"/>
                        <button
                            class="btn btn-blue w-100 px-2 my-2"
                            @click="useSignature"
                        >Adopt Your Saved Signature
                        </button>
                    </div>

                    <signature-pad
                        v-else
                        :key="mode"
                        :applicant="applicant"
                        :title="false"
                        :verification-signature="verificationSignature"
                        :contract-signature="contractSignature"
                        :timeline-url="timelineUrl"
                        :save-signature-url="saveSignatureUrl"
                        :submit-url="submitUrl"
                        :view-type="mode"
                        :get-existing-signature="getExistingSignature"
                        :save-reusable-signature="saveReusableSignature"
                    ></signature-pad>
                </div>
            </div>
        </x-modal>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    props: {
        open: {
            required: true,
            type: Boolean
        },
        timelineUrl: {
            required: true,
            type: String
        },
        submitUrl: {
            required: true,
        },
        saveSignatureUrl: {
            required: true,
            type: String
        },
        contractSignature: {
            required: false,
            type: Object
        },
        applicant: {
            required: false,
            type: Object
        },
        verificationSignature: {
            required: false,
            type: Boolean
        },
        getExistingSignature: {
            required: false
        },
        saveReusableSignature: {
            required: false
        }
    },
    data() {
        return {
            visible: false,
            overwriteSignature: false,
            mode: 'portrait-primary'
        };
    },
    computed: {
        ...mapGetters({
            customerSignature: "signature/getCustomerSignature"
        })
    },
    methods: {
        handleOrientationChange() {
            if (_.get(window, 'screen.orientation.type', false)) {
                this.mode = window.screen.orientation.type.includes('landscape') ? 'landscape-primary' : 'portrait-primary';
            }

            // iOS/safari
            this.mode = Math.abs(+window.orientation) === 90 ? 'landscape-primary' : 'portrait-primary';
        },
        useSignature() {
            this.$bus.$emit("add-signature", true);
            if (this.verificationSignature) this.$bus.$emit("verified", true);

            this.visible = false;
        }
    },
    mounted() {
        window.addEventListener("resize",
            this.handleOrientationChange
        );

        window.addEventListener("orientationchange",
            this.handleOrientationChange
        );

        this.handleOrientationChange();

        this.$bus.$on("close-modal", value => {
            this.visible = false;
        });
    },
    beforeDestroy() {
        this.$bus.$off("close-modal");
    },
    watch: {
        open(newVal, oldVal) {
            this.overwriteSignature = false;
            this.visible = newVal;
        },
        visible(newVal, oldVal) {
            this.$emit("update:open", newVal);
        }
    }
};
</script>
<style lang="scss">
.signature {
    &.mobile {
        .rotate-screen {
            display: none;
        }

        .readonly {
            pointer-events: none;
        }

        @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
            .rotate-screen {
                display: flex !important;
                align-items: center;
                justify-content: center;
                background-color: #fff;
                width: 100vw;
                height: 100vh;
                overflow-x: hidden;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 10000;
            }
        }

        @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
            .modal-wrapper {
                .draggable-modal {
                    max-width: 100vw !important;

                    .modal {
                        border-radius: 0rem;

                        .modal-body {
                            max-height: 100vh !important;
                            height: calc(100vh - 3.4rem) !important;
                            overflow-y: scroll;

                            &::-webkit-scrollbar {
                                display: none;
                            }

                            -ms-overflow-style: none;
                            scrollbar-width: none;

                            p {
                                font-size: 12px !important;
                            }

                            #bounding-north {
                                max-height: 100vh !important;

                                &::-webkit-scrollbar {
                                    display: none;
                                }

                                -ms-overflow-style: none;
                                scrollbar-width: none;
                            }
                        }
                    }
                }
            }
        }

        @media screen and (max-width: 980px) and (orientation: landscape) {
            .modal-wrapper {
                .draggable-modal {
                    width: 100vw !important;
                    max-width: 100vw !important;

                    .modal {
                        border-radius: 0rem;

                        .modal-body {
                            max-height: 100vh !important;
                            width: 100vw !important;
                            height: calc(100vh) !important;
                            overflow: hidden;

                            &::-webkit-scrollbar {
                                display: none;
                            }

                            -ms-overflow-style: none;
                            scrollbar-width: none;

                            p {
                                font-size: 12px !important;
                            }

                            #bounding-north {
                                max-height: 100vh !important;

                                &::-webkit-scrollbar {
                                    display: none;
                                }

                                -ms-overflow-style: none;
                                scrollbar-width: none;
                            }
                        }
                    }
                }
            }
        }

        &.landscape {
            .modal-wrapper {
                .modal {
                    .modal-heading {
                        position: absolute;
                        bottom: -3.4rem;
                        left: 0;
                        width: 100vh;
                        transform: rotate(270deg);
                        transform-origin: 0 0;
                        z-index: 100;
                    }
                }
            }
        }
    }
}
</style>
